import { Component } from 'react';

export default class EditPopUp extends Component{
   
    handleEdit = () => {
        const { getActiveEditData, ...rest } = this.props;
        this.props.getActiveEditData(rest);
    };

    render(){
        const { content } = this.props
        return(
            <>
                  <a className='role-name-disable' onClick={ this.handleEdit }> <span>{ content }</span> </a>
            </>
        )
    }
}